/**
* Bug #475
* @Author Anish Chandran
* @Date 5 July 2021
*/
import { Empty } from 'components';
import style from './style/noresultFound.module.scss'
import messagelistempty from '../client/assets/images/messagelistempty.png';
import sentEmpty from '../client/assets/images/sentEmpty.png';
import saveDraft from '../client/assets/images/saveDraft.png';
import starredEmpty from '../client/assets/images/starredEmpty.png';
import { messageContext } from 'contexts/messageContext';
import { OPEN_DRAFT, OPEN_INBOX, OPEN_OUTBOX, OPEN_STARRED } from "config/constants";
import { useContext } from 'react';

interface Props {
    message: string,
    className?: React.CSSProperties | String
}

const NoMessageFound = (props: Props) => {
    const { state } = useContext(messageContext);
    const messageEmptyImage= ()=>{
        if(state?.menuAction == OPEN_INBOX)
        return messagelistempty;
        else if(state?.menuAction == OPEN_OUTBOX)
        return sentEmpty;
        else if(state?.menuAction == OPEN_DRAFT)
        return saveDraft;
        else if(state?.menuAction == OPEN_STARRED)
        return starredEmpty; 
    }
    
    return (
        /** Bug#1009
         *  @Author: Midhila Velayudhan
         *  @Date: 11/10/2022
         */
        <Empty
            className={`${style.msgEmptychild} ${props.className}`}
            image={messageEmptyImage()}
            description={<span>{props.message}</span>}
        >
        </Empty>
        /**End Bug#502 */
    );
};

export default NoMessageFound;

/** End  **/
